export const isBrowser = () => typeof window !== "undefined";
export const getWindow = () => {
    return isBrowser() ? window : undefined;
};
//# sourceMappingURL=WindowUtil.js.map